var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.subscriptionPayment &&
    (_vm.subscriptionPayment.has_trial || _vm.hasTrial)
    ? _c("div", { staticStyle: { "padding-bottom": "1.5rem" } }, [
        _c(
          "p",
          {
            staticClass: "subtitle has-text-centered",
            staticStyle: { "margin-bottom": "0.2rem" },
          },
          [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("profile.enter_last_info").toUpperCase())),
            ]),
          ]
        ),
        _vm.subscriptionPayment.special_trial
          ? _c(
              "p",
              {
                staticClass: "subtitle subtitle-payment",
                staticStyle: { "margin-bottom": "0.5rem" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("profile.payment_info_to_continue", {
                      date: _vm.getDate(_vm.subscriptionPayment.trial),
                    }) + " "
                  ) +
                    "\n" +
                    _vm._s(_vm.$t("profile.payment_info_to_continue1") + " ")
                ),
                _c("span", { staticStyle: { "font-weight": "700" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("profile.payment_info_to_continue2") + " ")
                  ),
                ]),
                _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue3"))),
              ]
            )
          : _c(
              "p",
              {
                staticClass: "subtitle subtitle-payment",
                staticStyle: { "margin-bottom": "0.5rem" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("profile.payment_info_to_continue_month") + " "
                  ) +
                    "\n" +
                    _vm._s(_vm.$t("profile.payment_info_to_continue1") + " ")
                ),
                _c("span", { staticStyle: { "font-weight": "700" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("profile.payment_info_to_continue2") + " ")
                  ),
                ]),
                _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue3"))),
              ]
            ),
        _c(
          "p",
          {
            staticClass: "subtitle subtitle-payment",
            staticStyle: { "margin-bottom": "0.5rem" },
          },
          [
            _c("span", { staticStyle: { "font-weight": "700" } }, [
              _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue4") + " ")),
            ]),
            _c("br"),
            _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue5"))),
            _c("ol", { staticStyle: { "padding-left": "1.1rem" } }, [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_1"))),
              ]),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_2"))),
              ]),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_3"))),
              ]),
            ]),
          ]
        ),
        _c("p", { staticClass: "subtitle subtitle-payment" }, [
          _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_4"))),
        ]),
      ])
    : _vm.subscriptionPayment
    ? _c("div", { staticStyle: { "padding-bottom": "1.5rem" } }, [
        _c(
          "p",
          {
            staticClass: "subtitle has-text-centered",
            staticStyle: { "margin-bottom": "0.2rem" },
          },
          [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("profile.enter_last_info_payment").toUpperCase())
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }